import { useEffect, useState } from "react";
import BotaoContato from "../../componentes/BotaoContato/BotaoContato.js";
import "./ServicosEngAplicadaProjTec.css";
import BannerPaginaInterna from "../BannerPaginaInterna/BannerPaginaInterna.js";
import Servicos from "../Servicos/Servicos.js";
import Projetos from "../Projetos/Projetos.js";
import Contato from "../Contato/Contato.js";

function ServicosEngAplicadaProjTec() {
  const [openItem, setOpenItem] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-reveal-zoom");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.2 },
    );

    elements.forEach((el) => observer.observe(el));
    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div>
      <BannerPaginaInterna
        tag="Soluções Ambientais"
        titulo="Projetos e Consultoria Ambiental"
        descricao="Atuamos com soluções completas em engenharia ambiental, garantindo conformidade legal e eficiência técnica."
        textoBotao="Solicitar Orçamento"
        rotaBotao="https://wa.me/5532984053160?text=Olá, quero um orçamento"
        mostrarBotaoOutline={true}
        textoBotaoOutline="Fale com Especialista"
        rotaBotaoOutline="https://wa.me/5532984053160?text=Olá, quero falar com um especialista"
      />
      <main className="servicos-page py-5">
        {/* HEADER */}

        {/* LISTA COM DETAILS */}
        <section className="s scroll-reveal-zoom">
          <div className="titulo-bloco">
            <h2>Nossos Serviços Especializados</h2>
            <p>
              Clique nos itens abaixo para conhecer detalhes de nossa atuação
              técnica.
            </p>
          </div>

          <p>
  A <strong>Âmbar Soluções em Engenharia e Meio Ambiente</strong> atua no desenvolvimento de 
  <strong> projetos técnicos de engenharia ambiental, geotécnica e saneamento</strong>, oferecendo 
  soluções completas para empreendimentos que necessitam de <strong>regularização ambiental, controle de impactos e infraestrutura ambiental eficiente</strong>.
</p>

<p>
  Nossa atuação integra <strong>engenharia aplicada, estudos ambientais e planejamento técnico</strong>, 
  garantindo que cada projeto seja concebido com base em <strong>critérios técnicos, viabilidade ambiental e conformidade com a legislação vigente</strong>.
</p>

<p>
  Atendemos empresas e empreendedores nos estados de <strong>Minas Gerais e Rio de Janeiro</strong>, 
  principalmente nos setores de <strong>mineração, indústria, infraestrutura e serviços públicos</strong>, 
  desenvolvendo projetos que auxiliam na implantação, operação e regularização ambiental de empreendimentos.
</p>

<p className="mb-4">
  Entre nossos diferenciais estão o <strong>alto rigor técnico</strong>, o 
  <strong> acompanhamento próximo dos clientes</strong> e a experiência em processos junto a órgãos ambientais.
</p>

          <div className="accordion">
            <div className="accordion">
              {/* ITEM 17 */}
              <details
                className="item"
                open={openItem === 17}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenItem(openItem === 17 ? null : 17);
                }}
              >
                <summary className="item-summary">
                  <div className="item-header">
                    <p className="item-titulo">
                      Projetos de Sistemas de Controle Ambiental
                    </p>
                  </div>
                  <span className="icone">
                    <i className="fa-solid fa-chevron-down"></i>
                  </span>
                </summary>

                <div className="item-conteudo">
                  <div className="bloco-descricao-servico">
                    <p>
                      Desenvolvemos{" "}
                      <strong>
                        projetos de sistemas de controle ambiental
                      </strong>{" "}
                      voltados para a
                      <strong> mitigação de impactos ambientais</strong> e o
                      atendimento às
                      <strong> exigências de licenciamento ambiental</strong>.
                      <br />
                      Os projetos incluem <strong>dimensionamento</strong>,{" "}
                      <strong>avaliação</strong> e
                      <strong>
                        {" "}
                        otimização de estruturas e dispositivos de controle
                      </strong>
                      , voltados para
                      <strong>
                        {" "}
                        gestão de efluentes, sedimentos, drenagem e resíduos
                      </strong>
                      .
                      <br />
                      Os sistemas são projetados considerando{" "}
                      <strong>condições locais</strong>,
                      <strong> características do empreendimento</strong> e
                      <strong> requisitos regulatórios</strong>, garantindo{" "}
                      <strong>eficiência operacional</strong> e
                      <strong> segurança ambiental</strong>.
                    </p>

                    <p className="subtitulo-descricao mt-5">
                      <strong>Principais projetos:</strong>
                    </p>
                    <ul className="lista-servico-detalhada">
                      <li>
                        <strong>Sistemas de controle de sedimentos</strong>
                      </li>
                      <li>
                        <strong>Estruturas de contenção ambiental</strong>
                      </li>
                      <li>
                        <strong>
                          Dispositivos de dissipação de energia hidráulica
                        </strong>
                      </li>
                      <li>
                        <strong>
                          Estruturas de drenagem e controle de erosão
                        </strong>
                      </li>
                      <li>
                        <strong>
                          Sistemas de retenção e contenção de efluentes
                        </strong>
                      </li>
                    </ul>

                    <BotaoContato
                      texto="Entre em Contato"
                      rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Sistemas de Controle Ambiental"
                    />
                  </div>
                </div>
              </details>

              {/* ITEM 18 */}
              <details
                className="item"
                open={openItem === 18}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenItem(openItem === 18 ? null : 18);
                }}
              >
                <summary className="item-summary">
                  <div className="item-header">
                    <p className="item-titulo">
                      Estudos Hidrológicos, Hidráulicos e Drenagem
                    </p>
                  </div>
                  <span className="icone">
                    <i className="fa-solid fa-chevron-down"></i>
                  </span>
                </summary>

                <div className="item-conteudo">
                  <div className="bloco-descricao-servico">
                    <p>
                      Elaboramos{" "}
                      <strong>estudos hidrológicos e hidráulicos</strong>{" "}
                      aplicados à
                      <strong> engenharia ambiental e infraestrutura</strong>,
                      fundamentais para o<strong> planejamento de obras</strong>{" "}
                      e prevenção de <strong>riscos</strong>.
                      <br />
                      Esses estudos subsidiam o{" "}
                      <strong>
                        dimensionamento de sistemas de drenagem pluvial
                      </strong>
                      ,<strong> bacias de contenção</strong> e{" "}
                      <strong>estruturas hidráulicas</strong>, garantindo a{" "}
                      <strong>gestão adequada das águas superficiais</strong>.
                    </p>

                    <p className="subtitulo-descricao mt-5">
                      <strong>Serviços incluem:</strong>
                    </p>
                    <ul className="lista-servico-detalhada">
                      <li>
                        <strong>Estudos de chuva e vazão de projeto</strong>
                      </li>
                      <li>
                        <strong>Modelagem hidrológica de bacias</strong>
                      </li>
                      <li>
                        <strong>Dimensionamento de drenagem pluvial</strong>
                      </li>
                      <li>
                        <strong>Projetos de dissipadores de energia</strong>
                      </li>
                      <li>
                        <strong>Estudo de cotas de cheia</strong>
                      </li>
                      <li>
                        <strong>
                          Projetos de canalização e controle de escoamento
                        </strong>
                      </li>
                    </ul>

                    <BotaoContato
                      texto="Entre em Contato"
                      rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Estudos Hidrológicos e Drenagem"
                    />
                  </div>
                </div>
              </details>

              {/* ITEM 19 */}
              <details
                className="item"
                open={openItem === 19}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenItem(openItem === 19 ? null : 19);
                }}
              >
                <summary className="item-summary">
                  <div className="item-header">
                    <p className="item-titulo">
                      Avaliação Geotécnica e Projetos para Aterros e Pilhas
                    </p>
                  </div>
                  <span className="icone">
                    <i className="fa-solid fa-chevron-down"></i>
                  </span>
                </summary>

                <div className="item-conteudo">
                  <div className="bloco-descricao-servico">
                    <p>
                      Realizamos <strong>avaliações geotécnicas</strong> e
                      projetos de estruturas para
                      <strong> disposição de resíduos</strong>, com foco na{" "}
                      <strong>segurança estrutural</strong> e
                      <strong> conformidade ambiental</strong>.
                      <br />
                      Atendemos empreendimentos com{" "}
                      <strong>aterros de resíduos</strong>,
                      <strong> pilhas de estéril</strong> e áreas de disposição
                      controlada.
                    </p>

                    <p className="subtitulo-descricao mt-5">
                      <strong>Serviços incluem:</strong>
                    </p>
                    <ul className="lista-servico-detalhada">
                      <li>
                        <strong>Avaliação geotécnica de aterros</strong>
                      </li>
                      <li>
                        <strong>Análise de estabilidade de pilhas</strong>
                      </li>
                      <li>
                        <strong>Projetos de DTR (Depósitos de Rejeitos)</strong>
                      </li>
                      <li>
                        <strong>Projetos de aterros sanitários</strong>
                      </li>
                      <li>
                        <strong>Estudos de estabilidade geotécnica</strong>
                      </li>
                    </ul>

                    <BotaoContato
                      texto="Entre em Contato"
                      rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Avaliação Geotécnica"
                    />
                  </div>
                </div>
              </details>

              {/* ITEM 20 */}
              <details
                className="item"
                open={openItem === 20}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenItem(openItem === 20 ? null : 20);
                }}
              >
                <summary className="item-summary">
                  <div className="item-header">
                    <p className="item-titulo">
                      Projetos de Tratamento de Água, Efluentes e Lodo
                    </p>
                  </div>
                  <span className="icone">
                    <i className="fa-solid fa-chevron-down"></i>
                  </span>
                </summary>

                <div className="item-conteudo">
                  <div className="bloco-descricao-servico">
                    <p>
                      Desenvolvemos{" "}
                      <strong>projetos de sistemas de tratamento</strong>{" "}
                      voltados para
                      <strong> eficiência operacional</strong> e atendimento às
                      <strong> exigências ambientais</strong>.
                    </p>

                    <p className="subtitulo-descricao mt-5">
                      <strong>Inclui:</strong>
                    </p>
                    <ul className="lista-servico-detalhada">
                      <li>
                        <strong>ETA – Estações de Tratamento de Água</strong>
                      </li>
                      <li>
                        <strong>
                          ETE – Estações de Tratamento de Efluentes
                        </strong>
                      </li>
                      <li>
                        <strong>Sistemas de tratamento de lodo</strong>
                      </li>
                      <li>
                        <strong>Tratamento de efluentes industriais</strong>
                      </li>
                      <li>
                        <strong>Avaliação e adequação de sistemas</strong>
                      </li>
                    </ul>

                    <BotaoContato
                      texto="Entre em Contato"
                      rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Tratamento de Água e Efluentes"
                    />
                  </div>
                </div>
              </details>

              {/* ITEM 21 */}
              <details
                className="item"
                open={openItem === 21}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenItem(openItem === 21 ? null : 21);
                }}
              >
                <summary className="item-summary">
                  <div className="item-header">
                    <p className="item-titulo">
                      Geoprocessamento e Mapas Temáticos
                    </p>
                  </div>
                  <span className="icone">
                    <i className="fa-solid fa-chevron-down"></i>
                  </span>
                </summary>

                <div className="item-conteudo">
                  <div className="bloco-descricao-servico">
                    <p>
                      Utilizamos{" "}
                      <strong>tecnologias de geoprocessamento</strong> e
                      <strong> análise espacial</strong> para elaboração de
                      <strong> mapas temáticos</strong> e diagnósticos
                      ambientais.
                    </p>

                    <p className="subtitulo-descricao mt-5">
                      <strong>Serviços incluem:</strong>
                    </p>
                    <ul className="lista-servico-detalhada">
                      <li>
                        <strong>Mapas temáticos ambientais</strong>
                      </li>
                      <li>
                        <strong>Análise espacial com SIG</strong>
                      </li>
                      <li>
                        <strong>Processamento de dados geográficos</strong>
                      </li>
                      <li>
                        <strong>Uso e ocupação do solo</strong>
                      </li>
                      <li>
                        <strong>Delimitação de áreas ambientais</strong>
                      </li>
                      <li>
                        <strong>Suporte ao licenciamento ambiental</strong>
                      </li>
                    </ul>

                    <BotaoContato
                      texto="Entre em Contato"
                      rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Geoprocessamento"
                    />
                  </div>
                </div>
              </details>

              {/* ITEM 22 */}
              <details
                className="item"
                open={openItem === 22}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenItem(openItem === 22 ? null : 22);
                }}
              >
                <summary className="item-summary">
                  <div className="item-header">
                    <p className="item-titulo">
                      Avaliação de Viabilidade Ambiental
                    </p>
                  </div>
                  <span className="icone">
                    <i className="fa-solid fa-chevron-down"></i>
                  </span>
                </summary>

                <div className="item-conteudo">
                  <div className="bloco-descricao-servico">
                    <p>
                      A <strong>avaliação de viabilidade ambiental</strong>{" "}
                      permite identificar
                      <strong> restrições ambientais</strong>,{" "}
                      <strong>requisitos legais</strong> e
                      <strong> riscos associados</strong> à implantação de
                      projetos.
                      <br />
                      Realizamos <strong>diagnósticos técnicos</strong> que
                      reduzem incertezas e apoiam a
                      <strong> tomada de decisão</strong>.
                    </p>

                    <p className="subtitulo-descricao mt-5">
                      <strong>Aplicações:</strong>
                    </p>
                    <ul className="lista-servico-detalhada">
                      <li>
                        <strong>Empreendimentos industriais</strong>
                      </li>
                      <li>
                        <strong>Projetos de mineração</strong>
                      </li>
                      <li>
                        <strong>Infraestrutura e obras civis</strong>
                      </li>
                      <li>
                        <strong>Ampliação de atividades produtivas</strong>
                      </li>
                    </ul>

                    <BotaoContato
                      texto="Entre em Contato"
                      rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Viabilidade Ambiental"
                    />
                  </div>
                </div>
              </details>
            </div>
          </div>
        </section>
      </main>
      <Projetos />
      <Servicos />
      <Contato />
    </div>
  );
}

export default ServicosEngAplicadaProjTec;
